<template>
    <div class="avatar-wrapper">
        <storage-image
                v-if="user.avatarFile"
                :file="user.avatarFile"
                :width="pxWidth"
                :height="pxHeight"
                :id="id"
        >
            <template
                    v-if="user.fullName"
                    slot="error"
            >
                <div
                        class="avatar"
                        :style="style"
                        :class="['alert-' + color]"
                >
                    {{ user.fullName | initials(length) }}
                </div>
            </template>
        </storage-image>
        <div
                v-else-if="user.fullName"
                class="avatar"
                :style="[colorStyle, style]"
                :class="[this.uniqueColorSalt.length ? '' : 'alert-' + color]"
        >
            {{ user.fullName || '' | initials(length) }}
        </div>
        <b-tooltip
                v-if="showTooltip"
                :target="id"
                triggers="hover"
        >
            {{ user.fullName }}
        </b-tooltip>
    </div>
</template>

<script>
    import '@milestoneslabs/milestones-ui-kit/src/components/Avatar/Avatar.scss';
    import UserAppResource from '@milestoneslabs/milestones-core-js/src/AppResources/UserAppResource';
    import {generateRandomString} from '@milestoneslabs/milestones-ui-kit/src/helpers/stringHelpers';
    import StorageImage from "./StorageImage";
    import {colorHelper} from "@milestoneslabs/milestones-ui-kit/src/helpers/colorHelper";

    const COLORS = [
        'primary',
        'secondary',
        'success',
        'warning',
        'danger',
        'info',
        'dark'
    ];

    export default {
        name: 'StorageAvatar',
        components: {StorageImage},
        props: {
            user: {
                type: UserAppResource,
                required: true,
            },
            size: {
                type: Number,
                default: 2,
            },
            color: {
                type: String,
                default: 'primary',
                validator: (value) => {
                    return COLORS.indexOf(value) !== -1;
                }
            },
            uniqueColorSalt: {
                type: String,
                default: '',
            },
            length: {
                type: Number,
                default: 2,
                validator: (value) => {
                    return value >= 1 && value <= 2;
                }
            },
            showTooltip: {
                type: Boolean,
                default: false,
            }
        },
        data() {
            return {
                id: null,
                pxHeight: null,
                pxWidth: null,
            };
        },
        computed: {
            colorStyle() {
                if (!this.uniqueColorSalt) {
                    return {};
                }

                let uniqueColorSaltNumerical = colorHelper.hashCode(this.uniqueColorSalt);
                let backgroundColor = colorHelper.intToRGB(uniqueColorSaltNumerical);
                let backgroundColorRgb = colorHelper.convertHexToRgb(backgroundColor);
                let textColor = colorHelper.niceColor(backgroundColorRgb);

                return {
                    backgroundColor: `${backgroundColor}`,
                    color: `${textColor}`,
                };
            },
            style() {
                let fontSize = this.size * 38 / 100;
                return {
                    width: `${this.size}rem`,
                    height: `${this.size}rem`,
                    lineHeight: `${this.size}rem`,
                    fontSize: `${fontSize}rem`,
                };
            }
        },
        methods: {
            pxDimmensions() {
                this.pxWidth = this.convertRemToPixels(this.size);
                this.pxHeight = this.convertRemToPixels(this.size);
            }
        },
        beforeMount() {
            this.id = 'avatar-' + generateRandomString(32);
            this.pxDimmensions();
        },
        watch: {
            size: function (to, from) {
                this.pxDimmensions();
            }
        }
    };
</script>
<style>
    .avatar-wrapper .ms-storage-image {
        border-radius: 50%;
    }
</style>
